import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AlertController } from '@ionic/angular/standalone';
import { environment } from 'src/environments/environment';
import { NativeMarket } from "@capacitor-community/native-market";
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'bandon-shared';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  authService = inject(AuthenticationService)
  httpClient = inject(HttpClient)
  alertController = inject(AlertController)
  translate = inject(TranslateService)

  get isWeb(): boolean {
    return Capacitor.getPlatform() === 'web';
  }

  async checkForUpdate() {
    if(this.isWeb) {
      return;
    }

    const headers = new HttpHeaders().set('Authorization', 'Bearer '+environment.apiKey);
    const params = { version: environment.appVersion };
    this.httpClient.get<any>(environment.apiURL+"/app-version-check", {headers, params})
    .subscribe(
      (response) => {
        if(response.update_available) {
          let allowClose = true;
          let msg = this.translate.instant('MESSAGES.NEWVERSIONMSG');
          if(response.breaking_changes) {
            msg = this.translate.instant('MESSAGES.NEWBREAKINGVERSION');
          }
          this.presentAlert(this.translate.instant('MESSAGES.NEWVERSIONTITLE'),
            msg, 'Download', allowClose)
        }
      }
    );
  }

  openAppStoreEntry() {
    if(!this.isWeb) {
      let appId = "id1673700582";
      if (Capacitor.getPlatform() === "android") {
        appId = "ch.pmtbmbh.bandon.app";
      }
      NativeMarket.openStoreListing({
        appId: appId,
      });
    }
  }

  async presentAlert(header, message, buttonText = '', allowClose = false) {
    const buttons = []

    if (buttonText != '') {
      buttons.push({
        text: buttonText,
        handler: () => {
          this.openAppStoreEntry()
        }
      })
    }

    if (allowClose) {
      buttons.push({
        text: this.translate.instant('MESSAGES.CANCEL'),
        role: 'cancel'
      })
    }

    const alert = await this.alertController.create({
      header,
      message,
      buttons,
      backdropDismiss: allowClose,
      cssClass: 'band-on-alert'
    });
    alert.present();
  }
}
